import React from 'react'
import './home.css'
import Footer from '../component/Footer/footer';
import Navbar from '../component/NavBar/Navbar';
import Header from '../component/Header/header';
import Cars from '../component/Cars/Cars';
import OurService from '../component/OurService/ourService';

import { useEffect,useState } from 'react';
// import { BrowserRouter, Routes, Route } from 'react-router-dom';


const Homee = () => {

  const [innerWidth, setInnerWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setInnerWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  return (
    <div className='Home'>
      

         <Navbar title="VG Ghandhidham" ContactNumber="+91 9824345377" />
         <Header/>
         {innerWidth > 427 ? <Cars/>:"/About/cars"}
         <OurService/>
         <Footer/>
          
    </div>
  )
}

export default Homee
